import * as React from "react";
import { forwardRef } from "react";
const SvgProfileHeader = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 35, height: 35, viewBox: "0 0 35 35", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.5,15.188A7.594,7.594,0,1,0,5.906,7.594,7.6,7.6,0,0,0,13.5,15.188Zm6.75,1.687H17.344a9.18,9.18,0,0,1-7.689,0H6.75A6.749,6.749,0,0,0,0,23.625v.844A2.532,2.532,0,0,0,2.531,27H24.469A2.532,2.532,0,0,0,27,24.469v-.844A6.749,6.749,0,0,0,20.25,16.875Z", transform: "translate(1 1)", fill: "#fff" }));
const ForwardRef = forwardRef(SvgProfileHeader);
export default ForwardRef;
